import styled from '@emotion/styled'

export const Wrapper = styled.div`
  background: ${props => props.theme.primaryLight[props['data-color']] ?? props.theme.primaryLight.blue_gray};
  border-radius: .4em;
  border-top: .5em solid ${props => props.theme.primary[props['data-color']] ?? props.theme.primary.blue_gray};
  box-sizing: border-box;
  padding: 1em;
  overflow: hidden;
  color: ${props => props.theme.primaryDark[props['data-color']] ?? props.theme.primaryDark.blue_gray};
  position: relative;
`

export const Name = styled.span`
  display: block;
  text-align: center;
  margin-top: .7em;
  font-weight: 500;
`

export const Counters = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: .3em;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const Number = styled.span`
  font-size: 1.8em;
  font-weight: 500;
`

export const Label = styled.span`
  font-size: .8em;
`